import React from 'react';
import PropTypes from 'prop-types';
import { ContactInfo } from './ContactInfo';
import { Hours } from './Hours';
import { MarketingMedia } from './MarketingMedia';
import { NotesFeatures } from './NotesFeatures';
import { PropertyDetails } from './PropertyDetails';
import { TabView } from '../TabView';
import { useOverview } from './useOverview';
import { overviewPropTypes } from '../../../prop-types';
import {
  CONTACT_INFO,
  FEATURES,
  HOURS,
  MARKETING_MEDIA,
  PROPERTY_DETAILS,
} from './constants';

const Overview = ({ overview = {}, updateProperty }) => {
  const {
    clearFieldErrorMessage,
    handleOnSave,
    handleOnUndo,
    isActionsDisabled,
    onAddHolidayHours,
    overviewTabData,
    updateHours,
    updateOverviewSection,
    validationErrorMessages,
  } = useOverview({ overview, updateProperty });

  return (
    <TabView
      handleOnSave={handleOnSave}
      handleOnUndo={handleOnUndo}
      isActionsDisabled={isActionsDisabled}
    >
      <PropertyDetails
        clearFieldErrorMessage={clearFieldErrorMessage}
        propertyDetails={overviewTabData[PROPERTY_DETAILS]}
        updatePropertyDetails={updateOverviewSection(PROPERTY_DETAILS)}
        validationErrorMessages={validationErrorMessages}
      />

      <Hours
        hours={overviewTabData[HOURS] || {}}
        onAddHolidayHours={onAddHolidayHours}
        updateHours={updateHours}
      />

      <ContactInfo contactInfo={overviewTabData[CONTACT_INFO]} />

      <MarketingMedia
        clearFieldErrorMessage={clearFieldErrorMessage}
        marketingMedia={overviewTabData[MARKETING_MEDIA]}
        updateMarketingMedia={updateOverviewSection(MARKETING_MEDIA)}
        validationErrorMessages={validationErrorMessages}
      />

      <NotesFeatures
        notesFeatures={overviewTabData[FEATURES]}
        updateNotesFeatures={updateOverviewSection(FEATURES)}
      />
    </TabView>
  );
};

Overview.propTypes = {
  overview: overviewPropTypes,
  updateProperty: PropTypes.func,
};

export default Overview;
